module.exports = __webpack_public_path__ + "img/ic_star_white.efce48b1.svg";